import React from "react"
import TextField, {
    ITextFieldProps,
} from "../../../fields/components/text/TextField"

import "./Header.scss"
import { IBreadcrumb } from "../../index"

interface OwnProps {
    actions?: JSX.Element
    breadcrumb?: IBreadcrumb
    title: ITextFieldProps
    isTitleReadonly?: boolean
    extraClasses?: string
}

const Header: React.FC<OwnProps> = (props: OwnProps) => {
    const { extraClasses, breadcrumb, title, actions } = props
    return (
        <header className={`header ${extraClasses}`}>
            <div className="header__inner">
                <section className="NewUI-item-header__main">
                    <>
                        {breadcrumb ? (
                            <div className="breadcrumbs tw-pt-2 tw-pl-6">
                                <div className="label">
                                    {`${breadcrumb.listName} · ${breadcrumb.number}`}
                                </div>
                                <button
                                    className="toolbox-action label | JS_toggleModal JS_helpWizardTrigger"
                                    data-modal="#modalBreadcrumbsList"
                                >
                                    
                                </button>
                            </div>
                        ) : (
                            <></>
                        )}

                        {!!title && (
                            <TextField
                                {...title}
                                extraClasses="h2"
                                hideTitle={true}
                            />
                        )}
                    </>
                </section>
                <aside>{actions}</aside>
            </div>
        </header>
    )
}
export default Header
